/**
 * Kundenportal Api
 * Kundenportal Api
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface LanguageConfiguration { 
    languages: Array<LanguageConfiguration.LanguagesEnum>;
}
export namespace LanguageConfiguration {
    export type LanguagesEnum = 'de' | 'fr' | 'it';
    export const LanguagesEnum = {
        DE: 'de' as LanguagesEnum,
        FR: 'fr' as LanguagesEnum,
        IT: 'it' as LanguagesEnum
    };
}


